export class Eap {
    id: string;
    vesselId: string;
    index: number;
    location: string;
    screenDisplay: EapScreenDisplayType;
    eapLedPatternId?: string | null;
}

export const eapScreenDisplay = {
    LCD: 'LCD',
    LED: 'LED',
} as const;

export type EapScreenDisplayType = (typeof eapScreenDisplay)[keyof typeof eapScreenDisplay];

export const eapMax = 20;

export class EapLedPattern {
    id: string;
    vesselId: string;
    name: string;
    pattern: EapLedPatternConfiguration;
}

export const eapLedFunction = {
    ALARM: 'ALARM',
    MAN_UNMAN: 'MAN_UNMAN',
    WHO_DUTY: 'WHO_DUTY',
    ON_DUTY: 'ON_DUTY',
    ENGINEER_CALL: 'ENGINEER_CALL',
} as const;

export type EapLedFunction = (typeof eapLedFunction)[keyof typeof eapLedFunction];
export type EapLedManUnman = 'MAN' | 'UNMAN';
export type EapLedDutyStatus = 'ON_DUTY' | 'NOT_ON_DUTY';

export interface EapLedConfiguration {
    led: number;
    function: EapLedFunction | null;
    alarmGroupId?: string;
    dutyRole?: string;
    manUnman?: EapLedManUnman;
    onDuty?: EapLedDutyStatus;
}

export interface EapLedPatternConfiguration {
    leds: EapLedConfiguration[];
}
